import * as classNames from "classNames";
import * as React from "react";
import { debounce } from "lodash";
import { Div } from "../../../react-core/Html/Div";
import { CommonHelper } from "../../../react-core/Helpers/CommonHelper";
import { Spinner } from "../../../react-core/Html/Spinner";

export interface ISearchInputProps {
    label?: string;
    cssWrapper?: string;
    minLength?: number;
    apiClient: any;
    wait?: number;
    getText?: (data: any) => string;
    onClick?: (data: any) => void;
    onInputFocus?: () => void;
    customeChildren?: (data: any, searchInput: string) => JSX.Element;
    value?: string;
    resultKey?: string;
    placeholder?: string;
    disabled?: boolean;
    triggerOnlyByEnterKey?: boolean;
}

export interface ISearchInputStates {
    inputValue: string;
    data: any;
    isClickOutside: boolean;
    inputTooShort: boolean;
    pending:boolean;
}

export class SearchInput extends React.Component<ISearchInputProps, ISearchInputStates> {
    constructor(props: ISearchInputProps) {
        super(props);
        this.state = {
            inputValue: props.value,
            data: null,
            isClickOutside: false,
            inputTooShort: false,
            pending:false
        };
        this.doAjaxSearch = props.triggerOnlyByEnterKey
            ? this.doAjaxSearch
            : debounce(this.doAjaxSearch, props.wait || this.DEFAULT_WAIT);
    }

    private clearAfterClickOutside = false;

    private DEFAULT_WAIT = 500;
    private DEFAULT_LENGTH = 3;

    private handleClickOutside(e) {
        const target = e.target as HTMLElement;

        if (target.className == "ui-menu-item-wrapper" && target.id.includes("ui-id-")) {return;}

        this.setState({
            isClickOutside: true,
            inputTooShort: false,
        });
        if (this.props.triggerOnlyByEnterKey) {
            this.setState({ data: null });
        }

        if (this.clearAfterClickOutside && this.props.onClick) {
            this.clearAfterClickOutside = false;
            this.setState({ inputValue: "" });
            this.props.onClick(null);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value != this.props.value) {
            this.clearAfterClickOutside = false;

            this.setState({ inputValue: nextProps.value || "" });
        }
    }

    public render() {
        const cssClassNames = classNames("form-group search-form", this.props.cssWrapper);
        const { data, isClickOutside, inputValue, inputTooShort, pending } = this.state;
        const minLength = this.props.minLength || this.DEFAULT_LENGTH;
        return (
            <Div className={cssClassNames} onClickOutside={(e) => this.handleClickOutside(e)}>
                <div className="controls-wrap">
                    {this.props.label && (
                        <div className={"control-label"}>
                            <label htmlFor={this.props.label}>{this.props.label}</label>
                        </div>
                    )}
                    <div className="controls-text controls-autocomplete">
                        <input
                            placeholder={this.props.placeholder || ""}
                            type="text"
                            id={this.props.label}
                            value={this.state.inputValue}
                            onChange={(e) => this.inputOnchange(e)}
                            onFocus={() => this.onFocus()}
                            className="search-input"
                            disabled={this.props.disabled || false}
                            onKeyPress={(e) => {
                                if (e.key == "Enter") {
                                    if (
                                        inputValue != null &&
                                        inputValue.trim().replace(/ +/g, "").length >= minLength
                                    ) {
                                        this.doAjaxSearch(inputValue);
                                    } else {
                                        this.setState({ inputTooShort: true });
                                    }
                                }
                            }}
                        />
                        <button
                            className="search-icon"
                            aria-label="Search"
                            onClick={() => {
                                if (inputValue != null && inputValue.trim().replace(/ +/g, "").length >= minLength) {
                                    this.doAjaxSearch(inputValue);
                                } else {
                                    this.setState({ inputTooShort: true });
                                }
                            }}
                            style={this.props.triggerOnlyByEnterKey ? { cursor: "pointer" } : null}
                        ></button>
                        { pending &&(
                            <div className="text-center">
                            <Spinner notFull={true} />
                            </div> 
                           
                        )}
                        {!isClickOutside && data && !pending && (
                            <div>
                                {this.props.customeChildren
                                    ? this.props.customeChildren(data, this.state.inputValue)
                                    : this.optionChildrenRender(data)}
                            </div>
                        )}
                        {inputTooShort && this.inputTooShortRender()}
                    </div>
                </div>
            </Div>
        );
    }

    private optionChildrenRender(data: any[]): JSX.Element {
        return (
            <ul id="smart-search" className="ui-menu ui-autocomplete ui-front mt-50">
                {data.length > 0 ? (
                    data.map((option: any, index: number) => this.getOption(option, index))
                ) : (
                    <li className="ui-menu-item" key={`no-result`} id={`smart-search-${0}`}>
                        <div id={`ui-id-${0}`} className="ui-menu-item-wrapper">
                            No results Found
                        </div>
                    </li>
                )}
            </ul>
        );
    }

    private inputTooShortRender(): JSX.Element {
        return (
            <ul id="smart-search" className="ui-menu ui-autocomplete ui-front mt-50">
                <li className="ui-menu-item" key={`no-result`} id={`smart-search-${0}`}>
                    <div id={`ui-id-${0}`} className="ui-menu-item-wrapper">
                        Please enter a minimum of 3 characters (not including spaces) to trigger results
                    </div>
                </li>
            </ul>
        );
    }

    private getOption(option: any, index: number): JSX.Element {
        const text = this.props.getText(option);

        return (
            <li
                className="ui-menu-item"
                key={index.toString()}
                id={`smart-search-${index}`}
                onClick={() => {
                    this.clearAfterClickOutside = false;

                    this.setState({
                        inputValue: this.props.getText ? this.props.getText(option) : this.state.inputValue,
                        isClickOutside: true,
                        data: null,
                    });
                    this.props.onClick(option);
                }}
            >
                <div id={`ui-id-${index}`} className="ui-menu-item-wrapper">
                    <button>{text}</button>
                </div>
            </li>
        );
    }

    private inputOnchange(e) {
        let { minLength, triggerOnlyByEnterKey } = this.props;
        minLength = minLength || this.DEFAULT_LENGTH;

        this.clearAfterClickOutside = true;

        this.setState({
            inputValue: e.target.value,
            isClickOutside: false,
            inputTooShort: false,
        });
        if (triggerOnlyByEnterKey) {
            this.setState({ data: null });
        }
        if (e.target.value.length >= minLength && triggerOnlyByEnterKey !== true) {
            this.doAjaxSearch(e.target.value);
        }
    }

    private doAjaxSearch(value: string) {
        const promise = this.props.apiClient(value);
        this.setState({ pending: true });
        promise.onSuccess((data) => {
            if (this.props.resultKey) {data = data[this.props.resultKey];}
            this.setState({
                data: data,
                isClickOutside: false,
                pending: false
            });
        });
    }
    private onFocus() {
        // while focusing on inputting, should be after clicking inside
        this.setState(
            {
                isClickOutside: false,
            },
            this.props.onInputFocus
        );
    }
}
